import React, { useState, useCallback } from 'react';
import { Maybe, Request } from '@/graphql/__generated__/van-credits';
import CreateVanCredit from './CreateVanCredit';
import CreditDocuments from './CreateVanCredit/CreditDocuments';
import SignedDocuments from './CreateVanCredit/SignedDocuments';

interface VanCreditContainerProps {
	requestData: Maybe<Request> | undefined;
	refetchData: () => Promise<any>;
}

const VanCreditContainer: React.FC<VanCreditContainerProps> = ({ requestData, refetchData }) => {
	const [documentRefetchTrigger, setDocumentRefetchTrigger] = useState<number>(0);
	const showDocuments = !!requestData?.creditId && !!requestData?.clientId;

	const handleRefetchData = useCallback(async () => {
		await refetchData();
		setDocumentRefetchTrigger((prev) => prev + 1);
	}, [refetchData]);

	return (
		<div className="w-full">
			<CreateVanCredit requestData={requestData} refetchData={handleRefetchData} />

			{showDocuments && (
				<>
					<CreditDocuments
						clientId={requestData?.clientId || ''}
						creditId={requestData?.creditId || ''}
						refetchTrigger={documentRefetchTrigger}
					/>
					<SignedDocuments
						clientId={requestData?.clientId || ''}
						creditId={requestData?.creditId || ''}
						refetchTrigger={documentRefetchTrigger}
					/>
				</>
			)}
		</div>
	);
};

export default VanCreditContainer;
